<template>
  <div></div>
</template>
<script>
export default {
  created() {
    window.top.postMessage('close-signature-modal', '*');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/PdfSigned.vue